import { axiosBase } from '@/plugins/axios'

export class Rid {
  getProjectRids(code1C) {
    return axiosBase.get(`/v2/projects/rid/${code1C}`).then((response) => response.data)
  }

  createUnplanned(projectId) {
    return axiosBase.post(`/v2/projects/rid/init/${projectId}`).then((response) => response.data)
  }

  realize(projectId, ridCode) {
    return axiosBase
      .post(`/v2/projects/rid/create/${projectId}/${ridCode}`)
      .then((response) => response.data)
  }

  actualize(projectId, ridType, ridPlanCode, ridCode) {
    return axiosBase
      .post(`/v2/projects/rid/update/${projectId}`, { ridType, ridPlanCode, ridCode })
      .then((response) => response.data)
  }
}
